import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CustomizerSettingsService } from '../app/components/customizer-settings/customizer-settings.service';
import { ToggleService } from '../app/components/common/header/toggle.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { CoreTranslationService } from '@core/services/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { IdleService } from '@core/services/idle.service';
import { locale as menuEnglish } from 'app/shared/i18n/en';
import { locale as menuTamil } from 'app/shared/i18n/ta';
import { ChatRealtimeService } from './services/chat-realtime.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'P2C - App';
  isToggled = false;
  @BlockUI() blockUI: NgBlockUI;
  defaultLanguage: 'en'; // This language will be used as a fallback when a translation isn't found in the current language
  appLanguage: 'en'; // Set application default language i.e fr

  constructor(
    public router: Router,
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    private _coreTranslationService: CoreTranslationService,
    private _translateService: TranslateService,
    private _idleService: IdleService,
    private readonly chatRealtimeService: ChatRealtimeService
  ) {
    // Add languages to the translation service
    this._translateService.addLangs(['en', 'ta']);

    // This language will be used as a fallback when a translation isn't found in the current language
    this._translateService.setDefaultLang('en');

    // Set the translations for the menu
    this._coreTranslationService.translate(menuEnglish, menuTamil);
    this.toggleService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {
    // Initialize idle service
    this._idleService.init();
    this.chatRealtimeService.init();
  }
}
